import React from 'react';
import Footer from '../components/global-components/Footer';
import Layouts from '../components/global-components/Layouts';
import MissionVisionInner from '../components/section-components/MissionVision'
import HeaderV3 from '../components/section-components/Header-v3';


const MissionVision = () => {
    
    return (
       <Layouts  pageTitle="Mission & Vision">
           <HeaderV3 title={"Mission & Vision"} pageName={"Mission & Vision"}  />
           <MissionVisionInner />
           <div className="section-spacing"></div>
           <Footer />
       </Layouts>
    );
}

export default MissionVision;